import { useSourcesHealth } from '@/hooks/useSourcesHealth';
import HealthDashboardTable from '../../components/HealthDashboard/HealthDashboardTable/index';
import MetricsCard from '@/components/HealthDashboard/MetricsCard';

import { getHealthColor } from '@/components/HealthDashboard/utils';
import { useEffect, useState } from 'react';
import { Tag } from 'antd';
import dayjs from 'dayjs';
import useDebounce from '@/hooks/useDebounce';

const SourceHealthDashboard = () => {
	const [pagination, setPagination] = useState({
		page: 1,
		pageSize: 10,
	});
	const [searchValue, setSearchValue] = useState('');
	const debouncedSearch = useDebounce(searchValue, 500);

	useEffect(() => {
		setPagination((prev) => ({ ...prev, page: 1 }));
	}, [debouncedSearch]);

	const { healthData, healthKpi, dateOfLastFetch, fetchHealthData } = useSourcesHealth({
		autoFetch: true,
		page: pagination.page,
		pageSize: pagination.pageSize,
		search: debouncedSearch || undefined,
	});

	useEffect(() => {
		const interval = setInterval(() => {
			fetchHealthData();
		}, 900000);

		return () => {
			clearInterval(interval);
		};
	}, []);

	return (
		<div
			className="mt-[76px] bg-gray-50 p-3 overflow-auto"
			style={{ height: 'calc(100vh - 76px)' }}
		>
			{/* Header */}
			<div className="flex justify-between items-start mb-3">
				<div>
					<h1 className="text-3xl text-gray-900 mb-2 font-medium">Source Health Dashboard</h1>
					<Tag bordered={true}>
						<p className="text-gray-600 font-bold">
							Updated on {`${dayjs(dateOfLastFetch).format('D MMMM YYYY [at] h:mm A')}`}
						</p>
					</Tag>
				</div>
				{/* <button className="flex items-center space-x-2 bg-white border border-gray-300 px-4 py-2 rounded-lg hover:bg-gray-50 transition-colors">
					<DownloadOutlined size={16} />
					<span>Export</span>
				</button> */}
			</div>
			<h5 className="text-gray-600 mb-3">
				These metrics are aggregated at the organization level, including all locations and associated assets, for the last 24 hours.
			</h5>
			{/* Metrics Cards */}
			{healthKpi && (
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-3">
					{/* <MetricsCard
						title="Overall Source Health"
						value="95.5%"
						showProgress={true}
						progressValue={95.5}
						progressColor={getHealthColor(95.5)}
					/> */}
					<MetricsCard title="Total Sources" value={healthKpi.total} />
					<MetricsCard title="Physical Sources" value={healthKpi.physical} />
					<MetricsCard title="Virtual Sources (Model)" value={healthKpi.model} />
					<MetricsCard title="Virtual Sources (Calculated)" value={healthKpi.formula} />
				</div>
			)}
			
			<HealthDashboardTable
				infrastructureHealthData={healthData}
				pagination={pagination}
				setPagination={setPagination}
				searchValue={searchValue}
				setSearchValue={setSearchValue}
			/>
		</div>
	);
};

export default SourceHealthDashboard;
